<template>
    <h3 class="text-xl text-blue-700">
        <slot />
    </h3>
</template>
